<template>
	<!--
    	作者：YX
    	时间：2017-10-10
    	描述：登录页面
    -->
	<div class="sign-in">
			<img src="../assets/sign_title.png" class="sign_title">
	  <el-card class="form-box" @keyup.enter.native="signIn">
	    <div slot="header" style="width: 100%;text-align: center;font-size: 20px;letter-spacing: 5px;color:#4ea7ec;font-weight: 600;">
	      	登录账户
	    </div>
			<div style="border:1px solid #f2f2f2;overflow: hidden;">
				<span><img src="../assets/sign_username .png"></span>
	    	<input v-model="form.account" placeholder="请输入用户名" autofocus class="sign_input"> </input>
			</div>
	    <br />
	    <br />
	    <div style="border:1px solid #f2f2f2;overflow: hidden;">
				<span><img src="../assets/sign_password .png"></span>
	    	 <input v-model="form.password" placeholder="请输入密码" type="password" class="sign_input"></input>
			</div>
	   
	    <br />
	    <br />
	    <el-button style="width:100%;border-radius: 25px;line-height: 25px;font-size: 18px;letter-spacing: 8px;" type="primary" @click="signIn" 
	    	v-loading.fullscreen.lock="fullscreenLoading"> 登录 </el-button>
	    <h4>©保定市民益购售电服务有限公司 2019</h4>
	    <a href="https://beian.miit.gov.cn/" target="_blank" style="color: black;text-decoration: none;">冀ICP备17001612号-1</a>
	  </el-card>
	 	<div class="upLevel" v-if="showUpLevel">
	 		<div class="uplevel_content">
	 			<h2>更新公告</h2>
	 			<div class="uplevel_list">
	 				<h3>更新版本：v{{version}}</h3>
	 				<div class="uplevel_info">
	 					<strong>更新内容：</strong>
			 			<p v-html="content">
			 				
			 			</p>
	 				</div>
		 			<el-button type="primary" style="width: 100%;border-radius: 25px;color: black;background-color: white;font-size: 16px;letter-spacing: 2px;border: none;" @click="jumpToIndex">确定</el-button>
	 			</div>
	 			
	 		</div>
	 	</div>
	</div>

</template>
<style scoped lang="less">
.upLevel{
	position:absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0,0,0,.7);
}
.uplevel_content{
	width: 751px;
	margin:0 auto ;
	height: 528px;
	background-image: url(../assets/upLevelBg.png);
	background-size: 100% 100%;
	background-repeat: no-repeat;
	border-radius: 25px;
	margin-top: 8%;
	text-align: center;
}
.uplevel_content h2{
	font-size: 36px;
	color: white;
	letter-spacing: 1px ;
	padding: 20px;
	display: block;
}
.uplevel_list{
	padding:0 40px;
	height:380px ;
}
.uplevel_list h3{
	font-size: 18px;
	color: white;
	font-weight: normal;
	text-align: left;
}
.uplevel_info{
	height: 290px;
	overflow: auto;
	color: white;
}
.uplevel_info strong{
	display: block;
	float: left;
	font-size: 18px;
	font-weight: normal;
	height: 288px;
}
.uplevel_info p{
	font-size: 18px;
	text-align: left;
	float: left;
	line-height: 25px;
	display: block;
	width: 560px;
    margin: 0;
	
}
.sign-in {
  height:100vh;
  min-height:200px;
  display:flex;
  justify-content:center;
  align-items:center;
  background:url(../assets/bakcground-img.png)no-repeat center;
  background-size:100% 100%;
  .form-box {
    height:420px;
    width:450px;
    text-align: center;
  }
  .form-box h4{
	  margin: 20px 0 10px 0;
		font-weight: normal;
		color: #428bca;
  }
  .form-box a{
	  cursor: pointer;
	  font-size: 14px;
	  color: #222222;
  }
  .form-box a:hover{
	  color: #428bca !important;
  }
 .sign_title{
  	position: absolute;
  	left:30px;
  	top:20px;
  	overflow: hidden;
  }
  span{
  	display:inline-block;
  	margin: 0;
  	padding: 0;
  	height: 36px;
  	padding: 10px 25px 10px 25px;
  	float: left;
  	border-right:1px solid #f2f2f2;
  }
  .sign_input{
  	display: inline-block;
  	width: 302px;
  	height: 54px;
  	border:none;
  	font-size: 16px;
  	padding-left: 20px;
  }
}

</style>
<script>
import { mapMutations } from 'vuex'

export default {
  name: 'sign-in',
  data () {
    return {
      form: {
        account: '',
        password: ''
      },
      showUpLevel:false,
      version:'',
      create_time:'',
      content:'',
      fullscreenLoading:false
    }
  },
  methods: {
    signIn () {
    let password = this.form.password
    let account = this.form.account
    if(account == 0){
    	return this.$message({
    		type:'warning',
        	message:'请输入用户名',
        	duration:1000
        });
    }
    if(password == 0 ){
    	return this.$message({
    		type:'warning',
        	message:'请输入密码',
        	duration:1000
        });
    }
      this.fullscreenLoading = true;
      this.$jssdk.member.signIn(this.form, (data)=>{
      	this.setNature({
      		nature:data.nature
      	})
        this.setAuth(data)
        this.setRemark({
        	remark:data.remark
        })
        this.fullscreenLoading = false;
        this.setIsAdmin({
        	isAdmin:data.isadmin
        })
        this.setmenupower({
        	power:data.power
		})
        this.$jssdk.upgrade.getPolling({},(res)=>{
        	if(res.up == '0'){
        		this.$jssdk.upgrade.info({},(res)=>{
        			this.showUpLevel = true
        			this.create_time  = res.create_time
        			this.version = res.version
        			this.content = res.content
        		},(err)=>{
        			this.$message({
		        		type:'warning',
		        		message:err.msg,
		        		duration:1000
		        	})
        		})
        	}else{
        		this.$router.push({name:'index'})
        	}
        },(err)=>{
        	this.$message({
        		type:'warning',
        		message:err.msg,
        		duration:1000
        	})
        })
      }, (err)=>{
        this.$message.warning({
        	message:err.msg,
        	duration:1000
        });
        this.fullscreenLoading = false;
      })
    },
	  jumpToIndex(){
	  		this.showUpLevel = false
	  		this.$router.push({name:'index'})
	  },
    ...mapMutations([ 'setAuth', 'removeAuth','setIsAdmin','setmenupower','setRemark','setNature'])
  },
  created () {
   		this.removeAuth();
   		this.$router.push({name:'SignIn'})
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->




// WEBPACK FOOTER //
// SignIn.vue?1850e239